import React from "react"
import PropTypes from "prop-types"
import { Divider } from "@mui/material"
import {
  GridColumnMenuContainer,
  GridColumnMenuFilterItem,
  GridColumnMenuSortItem,
  GridColumnMenuPinningItem,
} from "@mui/x-data-grid-pro"

const CustomColumnMenu = props => {
  const { hideMenu, colDef, open } = props

  return (
    <GridColumnMenuContainer hideMenu={hideMenu} colDef={colDef} open={open}>
      <GridColumnMenuSortItem onClick={hideMenu} colDef={colDef} />
      <GridColumnMenuFilterItem onClick={hideMenu} colDef={colDef} />
      <Divider />
      <GridColumnMenuPinningItem onClick={hideMenu} colDef={colDef} />
    </GridColumnMenuContainer>
  )
}

CustomColumnMenu.propTypes = {
  hideMenu: PropTypes.func.isRequired,
  colDef: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
}

export default CustomColumnMenu
